import React, { useState } from 'react';

import { Form, InputField, SelectField } from 'components/Form';
import { Button, Dialog, DialogTitle } from 'components/Elements';

import { PencilIcon } from '@heroicons/react/solid';
import { useUpdateStatus } from '../api/updateStatus';

export const UpdateStatus = ({ id, status }) => {
  const [show, setShow] = React.useState(false);

  const updateStatusMutation = useUpdateStatus({ id });

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  const statusOptions = [
    { label: 'Inactive', value: 0 },
    { label: 'Active', value: 1 },
  ];

  return (
    <div className="">
      <div>
        <button onClick={handleOpen} className="flex flex-row items-center space-x-2">
          <PencilIcon className="h-[16px]" />
          <span>Update Status</span>
        </button>
        <Dialog isOpen={show} onClose={handleClose} initialFocus={null}>
          <div className="inline-block align-bottom bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <DialogTitle className="text-xl text-center font-bold mb-4">Update Status</DialogTitle>
            <Form
              id="update-status"
              onSubmit={async (values) => {
                await updateStatusMutation.mutateAsync({ data: { id, ...values } });
                handleClose();
              }}
              options={{
                defaultValues: {
                  status: status,
                },
              }}
            >
              {({ register, formState }) => (
                <>
                  <SelectField
                    label="Status"
                    error={formState.errors['status']}
                    registration={register('status')}
                    options={statusOptions}
                  />
                  <div className="flex flex-row items-center space-x-2">
                    <Button onClick={handleClose} variant="light" className="w-full" type="button">
                      Cancel
                    </Button>
                    <Button
                      className="w-full"
                      isLoading={updateStatusMutation.isLoading}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </Form>
          </div>
        </Dialog>
      </div>
    </div>
  );
};
